import { BarChart3, FileText } from "lucide-react";
import type { DashboardSummary } from "../../api/dashboardApi";

interface SummaryCardsProps {
  summary: DashboardSummary;
}

const formatCurrency = (value: number) =>
  new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    minimumFractionDigits: 0,
  }).format(value);

export default function SummaryCards({ summary }: SummaryCardsProps) {
  const items = [
    {
      icon: BarChart3,
      label: "Total Penjualan (Paid)",
      value: formatCurrency(summary.totalPenjualan),
    },
    {
      icon: FileText,
      label: "Quotation (Accept)",
      value: summary.quotationAccepted,
    },
    {
      icon: FileText,
      label: "Invoice (Paid)",
      value: summary.invoicePaid,
    },
    {
      icon: FileText,
      label: "Delivery Order (Done)",
      value: summary.deliveryOrderDone,
    },
  ];

  return (
    <div className="flex h-full flex-col justify-between gap-3 rounded-2xl bg-white p-5 shadow-sm">
      {items.map((item, index) => (
        <div
          key={index}
          className="flex items-center gap-4 rounded-2xl bg-slate-50 p-4">
          <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-[#3DA4A8] text-white">
            <item.icon size={22} />
          </div>
          <div>
            <p className="text-sm text-slate-500">{item.label}</p>
            <p className="text-xl font-bold text-[#324A5A]">{item.value}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
